<template>
    <header class="header" id="header-nav">
        <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-2 d-flex justify-content-start">
                <router-link class="logo" to="/" @click="menuClicked();">Tandzorg<span> Gestel</span></router-link>
              </div>
              <div class="col-8 d-flex justify-content-center">
                <nav class="nav"> 
                  <router-link to="/" :style="this.$store.state.activePage == 'Home' ? {'color': '#00b8b8'} : {}" @click="menuClicked(); makePageActive('Home'); DontScrollToRegisterSection();">Home</router-link>
                  <router-link to="/over-ons" :style="this.$store.state.activePage == 'AboutUs' ? {'color': '#00b8b8'} : {}" @click="menuClicked(); makePageActive('AboutUs');">Over ons</router-link>
                  <router-link to="/diensten" :style="this.$store.state.activePage == 'Services' ? {'color': '#00b8b8'} : {}" @click="menuClicked(); makePageActive('Services'); ScrollToServicesSection('header-nav');">Diensten</router-link>
                  <router-link to="/info" :style="this.$store.state.activePage == 'Info' ? {'color': '#00b8b8'} : {}" @click="menuClicked(); makePageActive('Info');">Info</router-link>
                  <router-link to="/het-team" :style="this.$store.state.activePage == 'TheTeam' ? {'color': '#00b8b8'} : {}" @click="menuClicked(); makePageActive('TheTeam');">Het team</router-link>
                  <router-link to="/de-lieve-tandarts" :style="this.$store.state.activePage == 'LieveTandarts' ? {'color': '#00b8b8'} : {}" @click="menuClicked(); makePageActive('LieveTandarts');">Lieve Tandarts</router-link>
                  <router-link to="/spoed" :style="this.$store.state.activePage == 'Spoed' ? {'color': '#00b8b8'} : {}" @click="menuClicked(); makePageActive('Spoed');">Spoed</router-link>               
                  <router-link to="/contact" :style="this.$store.state.activePage == 'Contact' ? {'color': '#00b8b8'} : {}" @click="menuClicked(); makePageActive('Contact');">Contact</router-link>
                  <div class="mobile-buttons">
                    <router-link to="/inschrijven" @click="menuClicked();" class="link-btn appointment-btn mobile-nav-btn">Inschrijven</router-link>
                    <router-link to="/afspraak-maken" @click="menuClicked();" class="link-btn appointment-btn mobile-nav-btn">Afspraak maken</router-link>
                  </div>
                </nav>
              </div>
              <div class="col-2 d-flex justify-content-end">
                <div class="header-buttons">
                  <router-link to="/inschrijven" class="link-btn">Inschrijven</router-link>
                  <router-link to="/afspraak-maken" class="link-btn appointment-btn">Afspraak maken</router-link>
                </div>
                <div @click="menuClicked();" id="menu-btn" class="fas fa-bars"></div>
              </div>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: "Header",
    methods: {
        menuClicked() {
        let menu = document.querySelector('#menu-btn');
        let navbar = document.querySelector('.header .nav');
        menu.classList.toggle('fa-times');
        navbar.classList.toggle('active');

      },
      makePageActive(activepage){
        this.$store.commit('updateActivePage', activepage)
      },
      ScrollToRegisterSection() {
        /* if active page is not home, first navigate, and then scroll down */
        if(this.$store.state.activePage != "Home") {
          this.$router.push({ path: '/' })
           this.$store.commit('updateScrollToRegister', true)   // make scrolling to register true in store
        }
        else {
           const element = document.getElementById('register-section');
           element.scrollIntoView({ behavior: 'smooth' });
        }
      },
      ScrollToAppointmentSection() {
        /* if active page is not home, first navigate, and then scroll down */
        if(this.$store.state.activePage != "Home") {
          this.$router.push({ path: '/' })
           this.$store.commit('updateScrollToAppointment', true)   // make scrolling to appointment true in store
        }
        else {
           const element = document.getElementById('register-section-appointment');
           element.scrollIntoView({ behavior: 'smooth' });
        }
      },
      DontScrollToRegisterSection(){
        this.$store.commit('updateScrollToRegister', false) 
      },
      ScrollToServicesSection(servicesection) {
          // this.$router.push({ path: '/diensten' })
          this.$store.commit('updateScrollToServices', servicesection)   // scroll to right service section 
      }
    }
}
</script>

<style scoped>
.header {
  padding: 2rem;
  border-bottom: var(--border);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
}
.header.active {
  background-color: var(--white);
  box-shadow: var(--box-shadow);
  border: 0;
}
.header .logo {
  font-size: 2.2rem; /* groter gemaakt passend bij navigatie */
  color:var(--black);
  text-decoration: none;
  font-weight: 700;
  white-space: nowrap;
}
.header .logo span {
  color: var(--blue);
}
.header .nav {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header .nav a {
  margin: 0 0.4rem;
  font-size: 1.9rem;
  color: var(--black);
  text-decoration: none;
  transition: 0.5s;
  font-weight: 500;
}
.header .nav a:hover {
  color: #808080;
}
.header .nav a.router-link-exact-active,
.header .nav a.router-link-active {
  color: var(--blue);
  font-weight: 700;
}
#menu-btn {
  font-size: 2.5rem;
  color: var(--black);
  cursor: pointer;
  display: none;
  margin-left: auto;
}

/* Header buttons styling */
.header-buttons {
  display: flex;
  gap: 0.8rem; /* iets meer ruimte tussen knoppen */
  align-items: center;
  justify-content: flex-end;
  min-width: 0; /* zorgt ervoor dat flexbox goed werkt */
}

.header-buttons .link-btn {
  padding: 0.8rem 1.5rem; /* iets minder padding voor betere proporties */
  font-size: 1.7rem; /* iets kleiner voor betere balans */
  font-weight: 700;
  border-radius: 8px; /* rondere hoeken voor moderne look */
  transition: all 0.3s ease; /* soepele overgang */
  white-space: nowrap; /* voorkomt dat tekst op nieuwe regel komt */
  letter-spacing: 0.01em;
  color: #ffffff !important;
}

.appointment-btn {
  background: linear-gradient(180deg, #00b8b8 0%, #009e9e 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 3px 10px rgba(0, 184, 184, 0.28);
  border: 1px solid rgba(255,255,255,0.25);
}

.appointment-btn:hover {
  background: linear-gradient(180deg, #009e9e 0%, #008a8a 100%) !important;
  transform: translateY(-1px); /* lichte lift effect */
  box-shadow: 0 6px 14px rgba(0, 184, 184, 0.35);
}

.mobile-buttons {
  display: none;
}

/* media queries */
/* @media (max-width: 991px) { */
  /* header */
  /* 
   */
/* } */

@media (max-width: 991px) {
    .header-buttons {
    display: none;
  }
  
  .mobile-buttons {
    display: flex;
  }
  
  #menu-btn {
    display: inline-block;
    transition: 0.2s linear;
  }
  #menu-btn.fa-times {
    transform: rotate(180deg);
  }
  
  .header .logo {
    font-size: 2rem; /* groter ook op mobiel */
    white-space: nowrap;
  }
  
  /* Mobiele layout aanpassing */
  .container-fluid .row .col-2:first-child {
    flex: 0 0 70%;
    max-width: 70%;
  }
  
  .container-fluid .row .col-8 {
    display: none;
  }
  
  .container-fluid .row .col-2:last-child {
    flex: 0 0 30%;
    max-width: 30%;
  }
  
  .header .nav {
    position: absolute;
    top: 99%; left: 0; right:0;
    background-color: var(--white);
    border-top: var(--border);
    border-bottom: var(--border);
    padding: 1rem 0;
    text-align: center;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
    transition: 0.2s linear;
  }
  .header .nav.active {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  }
  .header .nav a {
    margin: 1rem 0;
    font-size: 1.4rem;
  }
  
  .mobile-buttons {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #e0e0e0;
  }
  
  .mobile-nav-btn {
    font-size: 1.6rem !important;
    padding: 0.8rem 2rem !important;
    margin: 0 !important;
  }
}
</style>